import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationHexagonChoroplethIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M649.333 62.8921L932.731 133.742C948.757 137.748 960 152.147 960 168.667V924C960 936.477 953.54 948.064 942.926 954.623C932.313 961.183 919.06 961.779 907.9 956.199L649.333 826.916L374.667 964.249L83.9003 818.866C71.7041 812.768 64 800.302 64 786.667V100C64 88.9144 69.1074 78.4469 77.8452 71.6246C86.5829 64.8024 97.9766 62.3862 108.731 65.0749L374.667 131.559L649.333 62.8921ZM136 146.108V764.417L374.667 883.751L649.333 746.417L888 865.751V196.775L649.333 137.108L374.667 205.775L136 146.108Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M450.118 260.664L374.5 279.5L208 238V322.14L268.45 356.876L329 392L389.55 356.876L450.244 322L450.118 260.664Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M208 618.719V357.281L252.55 383.124L313.244 418L313.1 488L313.244 558L252.55 592.876L208 618.719Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M450.185 765.295L374.5 803L208 720V653.86L268.45 619.124L329 584L389.55 619.124L450.244 654L450.1 724L450.185 765.295Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M481.899 252.748L649.5 211L724.146 229.83L724.1 252L724.244 322L663.55 356.876L603 392L542.45 356.876L481.757 322L481.899 252.748Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M526.55 383.124L466 348L405.45 383.124L344.757 418L344.9 488L344.757 558L405.45 592.876L466 628L526.55 592.876L587.244 558L587.1 488L587.244 418L526.55 383.124Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M816 356.617V253L755.871 237.832L755.9 252L755.757 322L816 356.617Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M724.143 703.209L649.5 666L481.848 749.521L481.9 724L481.757 654L542.45 619.124L603 584L663.55 619.124L724.244 654L724.143 703.209Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M816 619.383V749L755.89 719.035L755.757 654L816 619.383Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M816 392.002V583.998L800.55 592.876L740 628L679.45 592.876L618.757 558L618.9 488L618.757 418L679.45 383.124L740 348L800.55 383.124L816 392.002Z",
      fill: "#5CBAEB"
    }
  )
] });
export {
  VisualisationHexagonChoroplethIcon
};
